import React from 'react'
import PropTypes from 'prop-types'

export default function AdMonitorRequest(props) {
	if(!props.subscribed) {
		return (
			<div className="booking-section">
				<div className="content-wrap">
					<h2>Get More For Free</h2>
					<p>We calculated these insights in <strong>{props.loadTime} seconds</strong>.<br />Imagine what we can deliver in a few minutes!</p>
					<p><strong>Get early access to our free AdMonitor service</strong> that delivers monthly score updates, industry benchmarks, and automated account insights.</p>
					<button className="cta" type="button" onClick={props.showSubscribeModal}>Monitor My Score Now</button>
				</div>
			</div>
		)
	} else {
		return (
			<div className="booking-section">
				<div className="content-wrap">
					<h2>You Are Subscribed!</h2>
					<p>
						You are now subscribed for this ad account! Want to run this report for another ad account?
					</p>
					<button className="cta" type="button" onClick={props.exitReport}>Run Another Report</button>
				</div>
			</div>
		)
	}
}

AdMonitorRequest.propTypes = {
	subscribed: PropTypes.bool.isRequired,
	loadTime: PropTypes.string.isRequired,
	exitReport: PropTypes.func.isRequired,
	showSubscribeModal: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/AdMonitorRequest.js